import * as React from 'react';
import { PlateElement } from 'platejs/react';
import { cn } from 'src/lib/utils';

export function ParagraphElement(props) {
  return (
    <PlateElement {...props} className={cn('m-0 px-0 py-1')}>
      {props.children}
    </PlateElement>
  );
}
